/** Statuts consultation — règles d’édition côté interface clinique */

export const CONSULTATION_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

export function isConsultationReadOnly(consultation) {
  const status = consultation?.status;
  return status === CONSULTATION_STATUS.COMPLETED || status === CONSULTATION_STATUS.CANCELLED;
}

export function isConsultationPending(consultation) {
  return consultation?.status === CONSULTATION_STATUS.PENDING;
}

export function getConsultationStatusTone(status) {
  if (status === CONSULTATION_STATUS.COMPLETED) return 'completed';
  if (status === CONSULTATION_STATUS.PENDING) return 'pending';
  if (status === CONSULTATION_STATUS.CANCELLED) return 'cancelled';
  return 'neutral';
}

export function getConsultationStatusLabelFr(status, hdEditor = null) {
  if (status === CONSULTATION_STATUS.COMPLETED) {
    return hdEditor?.STATUS_CHIP_COMPLETED || 'Terminée';
  }
  if (status === CONSULTATION_STATUS.PENDING) {
    return hdEditor?.STATUS_CHIP_PENDING || 'En cours';
  }
  if (status === CONSULTATION_STATUS.CANCELLED) {
    return hdEditor?.STATUS_CHIP_CANCELLED || 'Annulée';
  }
  return status || '—';
}

export function getConsultationLockMessage(consultation) {
  if (consultation?.status === CONSULTATION_STATUS.COMPLETED) {
    return 'Consultation terminée — dossier en lecture seule. Consultation et impression des actes possibles, sans modification.';
  }
  if (consultation?.status === CONSULTATION_STATUS.CANCELLED) {
    return 'Consultation annulée — aucune modification n’est autorisée.';
  }
  return null;
}

/** Consultation en file d’attente site (PENDING sans médecin assigné). */
export function isConsultationQueue(consultation) {
  return (
    consultation?.status === CONSULTATION_STATUS.PENDING &&
    (consultation.doctor_id == null || consultation.doctor_id === '')
  );
}

/** Consultation PENDING déjà prise en charge par un professionnel. */
export function isConsultationInProgress(consultation) {
  return consultation?.status === CONSULTATION_STATUS.PENDING && !isConsultationQueue(consultation);
}

/**
 * Statut affiché dans les listes — distingue file d’attente vs en cours vs terminée.
 */
export function getConsultationDisplayStatus(consultation, labels = {}) {
  const L = {
    queue: labels.queue || 'File d’attente',
    queueHint: labels.queueHint || 'Orientation réception',
    inProgress: labels.inProgress || 'En cours',
    inProgressHint: labels.inProgressHint || 'Prise en charge démarrée',
    completed: labels.completed || 'Terminée',
    completedHint: labels.completedHint || 'Dossier clôturé',
    cancelled: labels.cancelled || 'Annulée',
    cancelledHint: labels.cancelledHint || 'Sans prise en charge',
    ...labels
  };

  if (!consultation?.status) {
    return { tone: 'neutral', label: '—', hint: '', pulse: false };
  }

  if (consultation.status === CONSULTATION_STATUS.CANCELLED) {
    return { tone: 'cancelled', label: L.cancelled, hint: L.cancelledHint, pulse: false };
  }

  if (consultation.status === CONSULTATION_STATUS.COMPLETED) {
    return { tone: 'completed', label: L.completed, hint: L.completedHint, pulse: false };
  }

  if (consultation.status === CONSULTATION_STATUS.PENDING) {
    if (isConsultationQueue(consultation)) {
      return { tone: 'queue', label: L.queue, hint: L.queueHint, pulse: true };
    }
    return { tone: 'inprogress', label: L.inProgress, hint: L.inProgressHint, pulse: true };
  }

  return { tone: 'neutral', label: consultation.status, hint: '', pulse: false };
}

/** Filtre liste : QUEUE et IN_PROGRESS sont des sous-statuts client de PENDING. */
export function matchesConsultationListStatusFilter(consultation, statusFilter) {
  if (!statusFilter || statusFilter === 'ALL') return true;
  if (statusFilter === 'QUEUE') return isConsultationQueue(consultation);
  if (statusFilter === 'IN_PROGRESS') return isConsultationInProgress(consultation);
  return consultation?.status === statusFilter;
}
